import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="bg-prussian_blue py-16 px-4">
            <div className="max-w-2xl mx-auto text-center">
                <p className="font-script text-3xl md:text-4xl text-white/90 mb-3">Стас & Настя</p>
                <div className="flex items-center justify-center gap-4 my-5">
                    <span className="block w-12 h-px bg-gold/30" />
                    <span className="text-gold text-sm">✦</span>
                    <span className="block w-12 h-px bg-gold/30" />
                </div>
                <p className="font-sans text-xs tracking-[0.3em] uppercase text-white/40 mb-6">14 августа 2026</p>
                <p className="font-sans text-[10px] tracking-wider text-white/20">
                    Сделано с любовью
                </p>
            </div>
        </footer>
    );
};

export default Footer;

